var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVenmo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0.5H3C1.34315 0.5 0 1.84315 0 3.5V17.5C0 19.1569 1.34315 20.5 3 20.5H17C18.6569 20.5 20 19.1569 20 17.5V3.5C20 1.84315 18.6569 0.5 17 0.5Z",
    fill: "#3D8AF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8984 4.61328C15.3281 5.32031 15.5195 6.04688 15.5195 6.96875C15.5195 9.90234 13.0156 13.7148 10.9805 16.3906H6.33984L4.48047 5.25781L8.54688 4.87109L9.53516 12.793C10.4531 11.293 11.5898 8.9375 11.5898 7.33594C11.5898 6.45703 11.4375 5.85937 11.2031 5.36719L14.8984 4.61328Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenmo);
export default __webpack_public_path__ + "static/media/venmo.f8c742bc.svg";
export { ForwardRef as ReactComponent };